import classNames from "classnames";
import {useCatalogSelectedFilters} from "../model/useCatalogSelectedFilters";
import {SelectedFilter} from "@/entities/catalog";
import {Chip} from "@/shared/ui/Chip";

type Size = "s" | "m" | "l" | "xl" | "xxl";

type Props = {
    size?: Size;
    className?: string;
    selectedFilters: SelectedFilter[];
};

export const CatalogSelectedFilters = ({size = "l", className, selectedFilters}: Props) => {
    const {deleteFilter, resetAllFilters} = useCatalogSelectedFilters();

    if (!selectedFilters.length) {
        return null;
    }

    return (
        <div className={classNames(className)}>
            {selectedFilters.map((filter) => (
                <Chip key={filter.valueAlias} size={size} onRemove={() => deleteFilter(filter)}>{filter.value}</Chip>
            ))}
            {selectedFilters.length > 1 && (
                <Chip variant={`secondary`} size={size} onRemove={() => resetAllFilters()}>Очистить все</Chip>
            )}
        </div>
    );
};
